export const actions = {
  FETCH_OBJECTIVE_KEY_RESULTS: 'FETCH_OBJECTIVE_KEY_RESULTS',
  FETCH_OBJECTIVE_ALIGNMENT: 'FETCH_OBJECTIVE_ALIGNMENT',
  FETCH_FILTERED_OBJECTIVES: 'FETCH_FILTERED_OBJECTIVES',
  FETCH_OBJECTIVES_REQUEST: 'FETCH_OBJECTIVES_REQUEST',
  FETCH_SELECTED_OBJECTIVE: 'FETCH_SELECTED_OBJECTIVE',
  CLEAR_SELECTED_OBJECTIVE: 'CLEAR_SELECTED_OBJECTIVE',
  SAVE_OBJECTIVE_ALIGNMENT: 'SAVE_OBJECTIVE_ALIGNMENT',
  UPDATE_PROGRESS_REQUEST: 'UPDATE_PROGRESS_REQUEST',
  SET_SELECTED_OBJECTIVE: 'SET_SELECTED_OBJECTIVE',
  UPDATE_STATUS_REQUEST: 'UPDATE_STATUS_REQUEST',
  UPDATE_MANAGER_APPROVAL_STATUS_REQUEST:
    'UPDATE_MANAGER_APPROVAL_STATUS_REQUEST',
  RESEND_FOR_MANAGER_APPROVAL_REQUEST: 'RESEND_FOR_MANAGER_APPROVAL_REQUEST',
  UPDATE_OWNER_REQUEST: 'UPDATE_OWNER_REQUEST',
  UPDATE_TEAM_FOLLOWER: 'UPDATE_TEAM_FOLLOWER',
  UPDATE_TEAM_OWNER: 'UPDATE_TEAM_OWNER',
  UPDATE_TEAMS_REQUEST: 'UPDATE_TEAMS_REQUEST',
  DELETE_OBJECTIVE: 'DELETE_OBJECTIVE',
  SAVE_OBJECTIVES: 'SAVE_OBJECTIVES',
  SAVE_NEW_KR: 'SAVE_NEW_KR',
  FETCH_TEAM_DETAILS: 'FETCH_TEAM_DETAILS',
  SAVE_TEAM_DETAILS: 'SAVE_TEAM_DETAILS',
  UPDATE_TEAM_NAME: 'UPDATE_TEAM_NAME',
  UPDATE_TEAM_DESCRIPTION: 'UPDATE_TEAM_DESCRIPTION',
  DELETE_TEAM: 'DELETE_TEAM',
  UPDATE_OBJECTIVE: 'UPDATE_OBJECTIVE',
  UPDATE_OBJECTIVE_TOGGLE_KRS: 'UPDATE_OBJECTIVE_TOGGLE_KRS',
  TRIGGER_OBJECTIVE_REALTIME_EVENT: 'TRIGGER_OBJECTIVE_REALTIME_EVENT',
  UPDATE_OBJECTIVE_REALTIME_EVENT: 'UPDATE_OBJECTIVE_REALTIME_EVENT',
  COLLAPSE_OBJECTIVES: 'COLLAPSE_OBJECTIVES',
  TOGGLE_OBJECTIVE_OPEN_STATE: 'TOGGLE_OBJECTIVE_OPEN_STATE',
  HIDE_OBJECTIVE_ALIGNMENT: 'HIDE_OBJECTIVE_ALIGNMENT',
  SET_MOVE_OBJECTIVE: 'SET_MOVE_OBJECTIVE',
  UPDATE_OBJECTIVE_DETAILS_ACTION: 'UPDATE_OBJECTIVE_DETAILS_ACTION',
  PASTE_OBJECTIVE_REQUEST: 'PASTE_OBJECTIVE_REQUEST',
  GET_UPDATED_SELECTED_OBJECTIVE: 'GET_UPDATED_SELECTED_OBJECTIVE',
  DELETE_OBJECTIVE_IN_LIST: 'DELETE_OBJECTIVE_IN_LIST',
  POST_LABEL_OBJECTIVE: 'POST_LABEL_OBJECTIVE',
  UPDATE_DUE_DATE_REQUEST: 'UPDATE_DUE_DATE_REQUEST',
  UPDATE_START_DATE_REQUEST: 'UPDATE_START_DATE_REQUEST',
  UPDATE_DATE_REQUEST: 'UPDATE_DATE_REQUEST',
  SET_OBJECTIVE_TO_LINK_ACTION: 'SET_OBJECTIVE_TO_LINK',
  LINK_TO_OBJECTIVE: 'LINK_TO_OBJECTIVE',
  UNLINK_OBJECTIVE: 'UNLINK_OBJECTIVE',
  SAVE_LINKED_OBJECTIVES_ACTION: 'SAVE_LINKED_OBJECTIVES_ACTION',
  FETCH_LINKED_OBJECTIVES: 'FETCH_LINKED_OBJECTIVES',
  SAVE_NEW_DEPENDENCY_OBJECTIVE: 'SAVE_NEW_DEPENDENCY_OBJECTIVE',
  DELETE_DEPENDENCY_FROM_OBJECTIVES: 'DELETE_DEPENDENCY_FROM_OBJECTIVES',
  FETCH_SEARCH_RESULTS: 'FETCH_SEARCH_RESULTS',
  FETCH_VIEW_DASHBOARD_DATA: 'FETCH_VIEW_DASHBOARD_DATA',
  FETCH_VIEW_DASHBOARD_DATA_WITH_QUICK_FILTERS:
    'FETCH_VIEW_DASHBOARD_DATA_WITH_QUICK_FILTERS',
  SAVE_VIEW_DASHBOARD_DATA: 'SAVE_VIEW_DASHBOARD_DATA',
  FETCH_DASHBOARD_FILTERED_OBJECTIVES: 'FETCH_DASHBOARD_FILTERED_OBJECTIVES',
  UPDATE_OBJECTIVE_VISIBILITY: 'UPDATE_OBJECTIVE_VISIBILITY',
  UPDATE_OBJECTIVES_VISIBILITY: 'UPDATE_OBJECTIVES_VISIBILITY',
  SAVE_OBJECTIVE_IN_CONTEXT_DATA: 'SAVE_OBJECTIVE_IN_CONTEXT_DATA',
  CLEAR_ALIGNED_OBJECTIVE: 'CLEAR_ALIGNED_OBJECTIVE',
  UNLINK_WITH_GOOGLE_SHEETS: 'UNLINK_WITH_GOOGLE_SHEETS',
  LINKED_OBJECTIVE_POPUP: 'LINKED_OBJECTIVE_POPUP',
  OBJECTIVE_LINK_GETTING_VIEWED_FOR: 'OBJECTIVE_LINK_GETTING_VIEWED_FOR',
  TOGGLE_OBJECTIVES_KR_MOBILE: 'TOGGLE_OBJECTIVES_KR_MOBILE',
  SAVE_MOBILE_TRAVERSED_TREE_DATA: 'SAVE_MOBILE_TRAVERSED_TREE_DATA',
  RESET_TREE_TRAVERSE_STATE: 'RESET_TREE_TRAVERSE_STATE',
  GO_BACK_TO_PREVIOUS_STATE_MOBILE: 'GO_BACK_TO_PREVIOUS_STATE_MOBILE',
  SHOW_OBJECTIVE_LOADER: 'SHOW_OBJECTIVE_LOADER',
  UPDATE_VIEW_DASHBOARD_DATA: 'UPDATE_VIEW_DASHBOARD_DATA',
  SAVE_RECENTLY_DROPPED_OBJECTIVE: 'SAVE_RECENTLY_DROPPED_OBJECTIVE',
  CLEAR_RECENTLY_DROPPED_OBJECTIVE: 'CLEAR_RECENTLY_DROPPED_OBJECTIVE',
  FETCH_QUICK_FILTER_OBJECTIVES: 'FETCH_QUICK_FILTER_OBJECTIVES',
  SET_QUICK_FILTER_ATTRIBUTES: 'SET_QUICK_FILTER_ATTRIBUTES',
  SET_QUICK_FILTERS_SELECTED: 'SET_QUICK_FILTERS_SELECTED',
  FETCH_DASHBOARD_FILTERED_OBJECTIVES_FOR_QUICK_FILTERS:
    'FETCH_DASHBOARD_FILTERED_OBJECTIVES_FOR_QUICK_FILTERS',
  UPDATE_TEAM_QUICK_FILTER_ATTRIBUTES: 'UPDATE_TEAM_QUICK_FILTER_ATTRIBUTES',
  SET_SELECTED_ANNUAL_GOAL_FOR_ALIGNMENT:
    'SET_SELECTED_ANNUAL_GOAL_FOR_ALIGNMENT',
  SET_CREATE_OBJECTIVE_SELECTED_CYCLE: 'SET_CREATE_OBJECTIVE_SELECTED_CYCLE',
  SET_CREATE_OBJECTIVE_ACTION_STATUS: 'SET_CREATE_OBJECTIVE_ACTION_STATUS',
  SET_ANNUALLY_ALIGNED_OBJECTIVE_DETAILS:
    'SET_ANNUALLY_ALIGNED_OBJECTIVE_DETAILS',
  SET_ANNUAL_LINKED_OBJECTIVE_POPUP_DATA:
    'SET_ANNUAL_LINKED_OBJECTIVE_POPUP_DATA',
  GOTO_NEXT_PAGE: 'GOTO_NEXT_PAGE',
  RESET_PAGINATION_DATA: 'RESET_PAGINATION_DATA',
  SET_SELECTED_TEAM_QUICK_FILTERS: 'SET_SELECTED_TEAM_QUICK_FILTERS',
  EXPORT_CURRENT_VIEW_OBJECTIVES: 'EXPORT_CURRENT_VIEW_OBJECTIVES',
  UPDATE_PAGE_LOAD_IN_PROGRESS: 'UPDATE_PAGE_LOAD_IN_PROGRESS',
  SET_LAST_OBJECTIVE_IN_VIEW_ID: 'SET_LAST_OBJECTIVE_IN_VIEW_ID',
  SET_VIEW_ALIGNMENT_PREVIOUS_VIEW_STATE:
    'SET_VIEW_ALIGNMENT_PREVIOUS_VIEW_STATE',
  ALL_OBJECTIVES_FOR_REMINDER_DASHBOARD_VIEW:
    'ALL_OBJECTIVES_FOR_REMINDER_DASHBOARD_VIEW',
  UPDATE_MANAGER_APPROVAL_STATUS_FOR_KRS:
    'UPDATE_MANAGER_APPROVAL_STATUS_FOR_KRS',
  UPDATE_OBJECTIVES: 'UPDATE_OBJECTIVES',
  UPDATE_AUTOROLLUP_ATTRIBUTES_FOR_OBJECTIVE:
    'UPDATE_AUTOROLLUP_ATTRIBUTES_FOR_OBJECTIVE',
  SET_USER_RESTRICTIONS: 'SET_USER_RESTRICTIONS',
  SAVE_VIEW_DASHBOARD_DATA_SUMMARY: 'SAVE_VIEW_DASHBOARD_DATA_SUMMARY'
};

export const postLabelObjective = (requestBody, objective) => ({
  type: actions.POST_LABEL_OBJECTIVE,
  requestBody,
  objective
});

export const fetchObjectivesRequest = (
  requestBody,
  callback,
  appendObjectives = false,
  fetchAllObjectives = false
) => ({
  type: actions.FETCH_OBJECTIVES_REQUEST,
  requestBody,
  callback,
  appendObjectives,
  fetchAllObjectives
});

export const saveObjectives = (
  data,
  orderingVersion,
  paginationData,
  appendObjectives = false
) => ({
  type: actions.SAVE_OBJECTIVES,
  data,
  orderingVersion,
  paginationData,
  appendObjectives
});

// the third parameter i.e. "updateSelectedObjective" thought out app is only sent true only if you want to
// set objective in selectedObjective.
export const updateStatusRequest = (
  requestBody,
  objective,
  updateSelectedObjective
) => ({
  type: actions.UPDATE_STATUS_REQUEST,
  requestBody,
  objective,
  updateSelectedObjective
});

export const updateManagerApprovalStatusRequest = (
  requestBody,
  objective,
  updateSelectedObjective
) => ({
  type: actions.UPDATE_MANAGER_APPROVAL_STATUS_REQUEST,
  requestBody,
  objective,
  updateSelectedObjective
});

export const updateManagerApprovalStatusForKrs = objective => ({
  type: actions.UPDATE_MANAGER_APPROVAL_STATUS_FOR_KRS,
  objective
});

export const resendForManagerApproval = (
  requestBody,
  objective,
  updateSelectedObjective
) => ({
  type: actions.RESEND_FOR_MANAGER_APPROVAL_REQUEST,
  requestBody,
  objective,
  updateSelectedObjective
});

export const updateOwnerRequest = (
  requestBody,
  objective,
  updateSelectedObjective
) => ({
  type: actions.UPDATE_OWNER_REQUEST,
  requestBody,
  objective,
  updateSelectedObjective
});

export const updateProgressRequest = (
  requestBody,
  objective,
  updateSelectedObjective,
  callback
) => ({
  type: actions.UPDATE_PROGRESS_REQUEST,
  requestBody,
  objective,
  updateSelectedObjective,
  callback
});

export const updateTeamsRequest = (
  requestBody,
  objective,
  updateSelectedObjective
) => ({
  type: actions.UPDATE_TEAMS_REQUEST,
  requestBody,
  objective,
  updateSelectedObjective
});

export const updateDueDateRequest = (
  requestBody,
  objective,
  updateSelectedObjective
) => ({
  type: actions.UPDATE_DUE_DATE_REQUEST,
  requestBody,
  objective,
  updateSelectedObjective
});

export const updateStartDateRequest = (
  requestBody,
  objective,
  updateSelectedObjective
) => ({
  type: actions.UPDATE_START_DATE_REQUEST,
  requestBody,
  objective,
  updateSelectedObjective
});

export const updateTeamFollower = (
  team_id,
  requestBody,
  individualAction = true
) => ({
  type: actions.UPDATE_TEAM_FOLLOWER,
  team_id,
  requestBody,
  individualAction
});

export const updateTeamOwner = (team_id, requestBody) => ({
  type: actions.UPDATE_TEAM_OWNER,
  requestBody,
  team_id
});

export const deleteObjective = (objective, isObjective, delete_subtree) => ({
  type: actions.DELETE_OBJECTIVE,
  objective,
  isObjective,
  delete_subtree
});

export const fetchSelectedObjective = objective_id => ({
  type: actions.FETCH_SELECTED_OBJECTIVE,
  objective_id
});

export const fetchKeyResultsRequest = (objective, callback) => ({
  type: actions.FETCH_OBJECTIVE_KEY_RESULTS,
  objective,
  callback
});

export const setSelectedObjective = (data, parent_objective_owner) => ({
  type: actions.SET_SELECTED_OBJECTIVE,
  data,
  parent_objective_owner
});

export const clearSelectedObjective = () => ({
  type: actions.CLEAR_SELECTED_OBJECTIVE
});

export const saveNewKR = (objective, parent_objective_id) => ({
  type: actions.SAVE_NEW_KR,
  objective,
  parent_objective_id
});

export const saveNewDependencyObjective = (objective, parent_objective_id) => ({
  type: actions.SAVE_NEW_DEPENDENCY_OBJECTIVE,
  objective,
  parent_objective_id
});

export const fetchObjectiveAlignment = objective => ({
  type: actions.FETCH_OBJECTIVE_ALIGNMENT,
  objective
});

export const fetchFilteredObjectives = (
  filters,
  via_view_dashboard = false,
  callback,
  appendObjectives = false,
  disablePagination = false,
  isDemographicWithFilter = false
) => ({
  type: actions.FETCH_FILTERED_OBJECTIVES,
  filters,
  via_view_dashboard,
  callback,
  appendObjectives,
  disablePagination,
  isDemographicWithFilter
});

export const saveObjectiveAlignment = (data, objective) => ({
  type: actions.SAVE_OBJECTIVE_ALIGNMENT,
  data,
  objective
});

export const fetchTeamDetails = team_id => ({
  type: actions.FETCH_TEAM_DETAILS,
  team_id
});

export const saveTeamDetails = data => ({
  type: actions.SAVE_TEAM_DETAILS,
  data
});

export const updateTeamName = (id, value) => ({
  type: actions.UPDATE_TEAM_NAME,
  id,
  value
});

export const updateTeamDescription = (id, description) => ({
  type: actions.UPDATE_TEAM_DESCRIPTION,
  id,
  description
});

export const deleteTeam = id => ({
  type: actions.DELETE_TEAM,
  id
});

export const updateObjective = (objective, updateKRs = false) => ({
  type: actions.UPDATE_OBJECTIVE,
  objective,
  updateKRs
});

export const updateObjectives = (objectives, updateKRs = false) => ({
  type: actions.UPDATE_OBJECTIVES,
  objectives,
  updateKRs
});

export const updateObjectiveToggleKrs = objective => ({
  type: actions.UPDATE_OBJECTIVE_TOGGLE_KRS,
  objective
});

export const updateObjectivesDataRealtimeEvent = (
  objective,
  updateKRs = false,
  updateView = false,
  isSearchActive = false
) => ({
  type: actions.UPDATE_OBJECTIVE_REALTIME_EVENT,
  objective,
  updateKRs,
  updateView,
  isSearchActive
});

export const triggerObjectiveRealtimeUpdate = (
  objective_id,
  team_id,
  user_reference_id,
  isSearchActive,
  is_present_in_view
) => ({
  type: actions.TRIGGER_OBJECTIVE_REALTIME_EVENT,
  objective_id,
  team_id,
  user_reference_id,
  isSearchActive,
  is_present_in_view
});

export const collapseObjectives = () => ({
  type: actions.COLLAPSE_OBJECTIVES
});

export const toggleObjectiveOpenState = objective => ({
  type: actions.TOGGLE_OBJECTIVE_OPEN_STATE,
  objective
});

export const hideObjectiveAlignment = objective => ({
  type: actions.HIDE_OBJECTIVE_ALIGNMENT,
  objective
});

export const setMoveObjective = objective => ({
  type: actions.SET_MOVE_OBJECTIVE,
  objective
});

export const storeRecentlyUpdatedObjectiveDetails = objective_id => ({
  type: actions.UPDATE_OBJECTIVE_DETAILS_ACTION,
  objective_id
});

export const pasteObjectiveRequest = objective => ({
  type: actions.PASTE_OBJECTIVE_REQUEST,
  objective
});

export const getUpdatedSelectedObjective = () => ({
  type: actions.GET_UPDATED_SELECTED_OBJECTIVE
});

export const deleteObjectiveInList = objective => ({
  type: actions.DELETE_OBJECTIVE_IN_LIST,
  objective
});

export const setObjectiveToLink = objective => ({
  type: actions.SET_OBJECTIVE_TO_LINK_ACTION,
  objective
});

export const linkObjectiveRequest = (
  objective,
  objectiveToBeLinked,
  objective_prioritization_request,
  newPositionParams
) => ({
  type: actions.LINK_TO_OBJECTIVE,
  objective,
  objectiveToBeLinked,
  objective_prioritization_request,
  newPositionParams
});

export const unLinkObjectiveRequest = (
  linked_objective_id,
  dependent_objective_id
) => ({
  type: actions.UNLINK_OBJECTIVE,
  linked_objective_id,
  dependent_objective_id
});

export const fetchLinkedObjectives = objective => ({
  type: actions.FETCH_LINKED_OBJECTIVES,
  objective
});

export const saveLinkedObjectives = data => ({
  type: actions.SAVE_LINKED_OBJECTIVES_ACTION,
  data
});

export const deleteDependencyFromObjectives = (
  linked_objective_ids,
  dependency_objective_id,
  isDependencyObjectiveDeleted
) => ({
  type: actions.DELETE_DEPENDENCY_FROM_OBJECTIVES,
  linked_objective_ids,
  dependency_objective_id,
  isDependencyObjectiveDeleted
});

export const fetchSearchResults = search_term => ({
  type: actions.FETCH_SEARCH_RESULTS,
  search_term
});

export const fetchViewDashboardData = (
  dashaboardParams,
  filterParams,
  disableLoading
) => ({
  type: actions.FETCH_VIEW_DASHBOARD_DATA,
  dashaboardParams,
  filterParams,
  disableLoading
});

export const fetchViewDashboardDataWithQuickFilters = (
  requestBody,
  selectedDemographicKey
) => ({
  type: actions.FETCH_VIEW_DASHBOARD_DATA_WITH_QUICK_FILTERS,
  requestBody,
  selectedDemographicKey
});

export const saveViewDashboardData = data => ({
  type: actions.SAVE_VIEW_DASHBOARD_DATA,
  data
});

export const fetchDashboardFilteredObjectives = (
  filters,
  appendObjectives = false
) => ({
  type: actions.FETCH_DASHBOARD_FILTERED_OBJECTIVES,
  filters,
  appendObjectives
});

export const getObjectivesForRemindersInDashboardView = (
  filters,
  callback
) => ({
  type: actions.ALL_OBJECTIVES_FOR_REMINDER_DASHBOARD_VIEW,
  filters,
  callback
});

export const fetchDashboardFilteredObjectivesForQuickFilters = (
  filters,
  quickFiltersSelected,
  appendObjectives = false
) => ({
  type: actions.FETCH_DASHBOARD_FILTERED_OBJECTIVES_FOR_QUICK_FILTERS,
  filters,
  quickFiltersSelected,
  appendObjectives
});

export const updateObjectiveVisibilityRequest = (
  requestBody,
  objective,
  updateSelectedObjective
) => ({
  type: actions.UPDATE_OBJECTIVE_VISIBILITY,
  requestBody,
  objective,
  updateSelectedObjective
});

export const updateObjectivesVisibility = objective => ({
  type: actions.UPDATE_OBJECTIVES_VISIBILITY,
  objective
});

export const saveObjectiveInContextData = (
  objective,
  data,
  isLinkedObjective,
  switchObjectiveContextTreeForPrimaryObjectiveIfAvailable = false
) => ({
  type: actions.SAVE_OBJECTIVE_IN_CONTEXT_DATA,
  objective,
  data,
  isLinkedObjective,
  switchObjectiveContextTreeForPrimaryObjectiveIfAvailable
});

export const clearAlignedObjective = objective => ({
  type: actions.CLEAR_ALIGNED_OBJECTIVE,
  objective
});

export const unlinkWithGoogleSheets = (objective_id, version) => ({
  type: actions.UNLINK_WITH_GOOGLE_SHEETS,
  objective_id,
  version
});

export const showLinkedObjectivePopup = objective => ({
  type: actions.LINKED_OBJECTIVE_POPUP,
  objective
});

export const objectiveLinkGettingViewedFor = objective => ({
  type: actions.OBJECTIVE_LINK_GETTING_VIEWED_FOR,
  objective
});

export const saveMobileTraversedTreeData = data => ({
  type: actions.SAVE_MOBILE_TRAVERSED_TREE_DATA,
  data
});

export const exitTreeView = () => ({
  type: actions.RESET_TREE_TRAVERSE_STATE
});

export const toggleObjectiveKrsMobile = objective => ({
  type: actions.TOGGLE_OBJECTIVES_KR_MOBILE,
  objective
});

export const goBackToPreviousStateMobile = () => ({
  type: actions.GO_BACK_TO_PREVIOUS_STATE_MOBILE
});

export const showObjectiveLoader = value => ({
  type: actions.SHOW_OBJECTIVE_LOADER,
  value
});

export const updateViewDashboardData = value => ({
  type: actions.UPDATE_VIEW_DASHBOARD_DATA,
  value
});

export const saveRecentlyDroppedObjective = objective => ({
  type: actions.SAVE_RECENTLY_DROPPED_OBJECTIVE,
  objective
});

export const clearRecentlyDroppedObjective = () => ({
  type: actions.CLEAR_RECENTLY_DROPPED_OBJECTIVE
});

export const fetchQuickFilterObjectives = (
  requestBody,
  appendObjectives = false
) => ({
  type: actions.FETCH_QUICK_FILTER_OBJECTIVES,
  requestBody,
  appendObjectives
});

export const setQuickFilterAttributes = (data, updateOperation = false) => ({
  type: actions.SET_QUICK_FILTER_ATTRIBUTES,
  data: { ...data, updateOperation }
});

export const setQuickFiltersSelected = data => ({
  type: actions.SET_QUICK_FILTERS_SELECTED,
  data
});

export const updateTeamQuickFilterAttributes = () => ({
  type: actions.UPDATE_TEAM_QUICK_FILTER_ATTRIBUTES
});

export const setSelectedAnnualGoalForAlignment = objective => ({
  type: actions.SET_SELECTED_ANNUAL_GOAL_FOR_ALIGNMENT,
  objective
});

export const setCreateObjectiveSelectedCycle = cycle => ({
  type: actions.SET_CREATE_OBJECTIVE_SELECTED_CYCLE,
  cycle
});

export const setCreateObjectionActionStatus = data => ({
  type: actions.SET_CREATE_OBJECTIVE_ACTION_STATUS,
  data
});

export const setAnnuallyAlignedObjectiveDetails = data => ({
  type: actions.SET_ANNUALLY_ALIGNED_OBJECTIVE_DETAILS,
  data
});

export const saveAnnualLinkedObjPopupData = data => ({
  type: actions.SET_ANNUAL_LINKED_OBJECTIVE_POPUP_DATA,
  data
});

export const goToNextPage = () => ({
  type: actions.GOTO_NEXT_PAGE
});

export const resetPaginationData = () => ({
  type: actions.RESET_PAGINATION_DATA
});

export const setSelectedTeamQuickFilters = filters => ({
  type: actions.SET_SELECTED_TEAM_QUICK_FILTERS,
  filters
});

export const exportCurrentViewObjectives = () => ({
  type: actions.EXPORT_CURRENT_VIEW_OBJECTIVES
});

export const updatePageLoadInProgress = status => ({
  type: actions.UPDATE_PAGE_LOAD_IN_PROGRESS,
  status
});

export const setLastObjectiveInViewId = status => ({
  type: actions.SET_LAST_OBJECTIVE_IN_VIEW_ID,
  status
});

export const setViewAlignmentPreviousViewState = state => ({
  type: actions.SET_VIEW_ALIGNMENT_PREVIOUS_VIEW_STATE,
  state
});

export const updateAutoRollUpAttributes = (
  objective,
  requestBody,
  isObjectiveDetailsOpen = false
) => ({
  type: actions.UPDATE_AUTOROLLUP_ATTRIBUTES_FOR_OBJECTIVE,
  objective,
  requestBody,
  isObjectiveDetailsOpen
});

export const setUserRestrictions = data => ({
  type: actions.SET_USER_RESTRICTIONS,
  data
});
